import { createSlice } from "@reduxjs/toolkit";

export const CHAT_SLICE_NAME = "chat";

export const chatInitialState = {
  show: false,
};

export const ChatSlice = createSlice({
  name: CHAT_SLICE_NAME,
  initialState: chatInitialState,
  reducers: {
    toggleChat: (_state, action) => ({
      ...chatInitialState,
      show: action.payload,
    }),
  },
});

export const ChatActions = ChatSlice.actions;
export default ChatSlice.reducer;
